import React, { useCallback, useMemo } from 'react'

import { bool, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

import { TIER } from '../../../constants'

const PLAN_MONTHLY = 'monthly'
const PLAN_YEARLY = 'yearly'

const AI_ITEM_KEYS = [
  'keep_access',
  'no_generations',
  'keep_license_ai',
  'no_fee_no_commitment',
]

function resolveFeeKey({
  subscriptionV16Enabled, planType, gracePeriodEligible, commitmentReleased,
}) {
  // Monthly plans and released subscriptions never carry an early-cancellation fee, flag or not.
  // Guard first so v1.6-window monthly subscribers aren't shown a fee bullet once the flag is off.
  if (planType === PLAN_MONTHLY || commitmentReleased) return null
  if (!subscriptionV16Enabled) return 'subscription_management.active.cancel_info.cancellation_fee'
  if (planType === PLAN_YEARLY && !gracePeriodEligible) {
    return 'subscription_management.active.cancel_info.cancellation_fee_new_yearly'
  }
  return 'subscription_management.active.cancel_info.cancellation_fee'
}

function CancelInfo({
  locale = 'en',
  subscriptionV16Enabled = false,
  planType = PLAN_YEARLY,
  gracePeriodEligible = true,
  commitmentReleased = false,
  tier = TIER.ESSENTIALS,
}) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale]
  )

  const items = useMemo(() => {
    if (tier === TIER.AI_STUDIO) {
      return AI_ITEM_KEYS.map((key) => translate(`subscription_management.active.cancel_info.${key}`))
    }

    const feeKey = resolveFeeKey({
      subscriptionV16Enabled, planType, gracePeriodEligible, commitmentReleased,
    })

    return [
      translate('subscription_management.active.cancel_info.keep_access'),
      translate('subscription_management.active.cancel_info.no_downloads'),
      translate('subscription_management.active.cancel_info.keep_license'),
      feeKey ? translate(feeKey) : null,
    ].filter(Boolean)
  }, [translate, subscriptionV16Enabled, planType, gracePeriodEligible, commitmentReleased, tier])

  return (
    <div className="cancel-info">
      <h3 className="cgt-legacy-heading-h4">
        {translate('subscription_management.active.cancel_info.title')}
      </h3>
      <ul className="cancel-info__list">
        {items.map((item, index) => (
          <li key={index} className="cancel-info__item cgt-text-medium">
            {item}
          </li>
        ))}
      </ul>
    </div>
  )
}

CancelInfo.propTypes = {
  locale: string,
  subscriptionV16Enabled: bool,
  planType: string,
  gracePeriodEligible: bool,
  commitmentReleased: bool,
  tier: string,
}

export default CancelInfo
